import React from 'react';
import { Modal, Button, Header, Icon } from 'semantic-ui-react';
import { AiFillCheckCircle } from 'react-icons/ai';

interface ModalProps {
  message: string;
  success: boolean;
  trigger: React.ReactNode;
  handleClose: any;
  modalIsOpen: boolean;
  bondInsuranceId?: string;
  redirectToFireInsurance?: (bondInsuranceId: string) => void;
}

export const AppModal = (props: ModalProps) => {
  const { trigger, handleClose, modalIsOpen, bondInsuranceId, redirectToFireInsurance } =
    props;

  const handleFireInsuranceClick = () => {
    if (bondInsuranceId && redirectToFireInsurance) {
      redirectToFireInsurance(bondInsuranceId);
    }
  };

  return (
    <Modal trigger={trigger} open={modalIsOpen} onClose={handleClose} size="small">
      <Modal.Content style={{ padding: '0' }}>
        <div
          style={{
            backgroundColor: '#E2FFD2',
            padding: '15px',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '8px',
            margin: '20px'
          }}
        >
          <div style={{ marginRight: '20px' }}>
            <AiFillCheckCircle size={'40px'} color={'#4BB543'} />
          </div>
          <div>
            <Header
              content={'Solicitação enviada com sucesso!'}
              style={{ margin: '0 0 5px 0', fontWeight: 800, fontSize: '16px' }}
            />
            <p style={{ margin: 0, fontSize: '14px' }}>
              Em breve nossa equipe entrará em contato com você para dar andamento do
              processo.
            </p>
          </div>
        </div>
        <hr style={{ margin: '0 20px', color: '#DDDDDD' }} />
        {bondInsuranceId && redirectToFireInsurance && (
          <div style={{ padding: '20px' }}>
            <Header as="h3" style={{ fontWeight: 700, color: '#6B7280' }}>
              Faça também uma cotação no
              <span style={{ color: '#59249B', fontWeight: 700 }}> Seguro incêndio</span>
            </Header>
            <p>
              Clique no botão abaixo para aproveitar as informações da análise do Seguro
              Fiança e realizar um orçamento de Seguro Incêndio para seu cliente.
            </p>

            <div style={{ textAlign: 'center', margin: '20px 0' }}>
              <Button
                primary
                icon
                labelPosition="left"
                onClick={handleFireInsuranceClick}
                style={{ backgroundColor: '#854EE0' }}
              >
                <Icon name="fire extinguisher" size="large" />
                Novo orçamento
              </Button>
            </div>

            <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
              <div
                style={{
                  flex: '1',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px'
                }}
              >
                <p>
                  Você também pode realizar uma cotação rápida de Seguro Incêndio a partir
                  de uma <strong style={{ color: '#59249B' }}>Apólice</strong> do Seguro
                  Fiança!
                </p>
                <p>
                  Acesse o menu de Ações de uma das apólices e selecione{' '}
                  <strong style={{ color: '#59249B' }}>Cotar seguro incêndio</strong> para
                  acessar o formulário de orçamento com as informações pré-preenchidas.
                </p>
              </div>
              <div
                style={{
                  flex: '1',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <img
                  style={{ maxWidth: '100%', height: 'auto' }}
                  src="/exemplo-cotar_incendio.png"
                  alt="Seguro incêndio"
                />
              </div>
            </div>
          </div>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleClose}>Fechar</Button>
      </Modal.Actions>
    </Modal>
  );
};
